import { Product } from 'shared/types/quotes';

export function getProductRowKey(row: Product) {
  return `${row.totalQty}|${row.minOrderQty}|${row.modelName}|${row.tag}|${row.modelNumber}|${row.color}|${row.options}`;
}
